import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {ChatNudges} from 'shells/chat/chat-nudges';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {
    GetContextDocuments_contextDocuments_aiSuggestions as AiSuggestion,
    ChatSettingsKnowledgeFragment_lookAndFeel as LookAndFeel,
} from 'nutshell-graphql-types';

export function AiSuggestionsList({
    aiSuggestions,
    lookAndFeel,
}: {
    aiSuggestions: AiSuggestion[];
    lookAndFeel: LookAndFeel;
}) {
    if (aiSuggestions.length > 0) {
        const Nudges = () => {
            return (
                <ChatNudges
                    secondaryColor={lookAndFeel.secondaryColor}
                    suggestions={aiSuggestions}
                    isLoading={false}
                    alignItems='start'
                    isHorizontal={true}
                />
            );
        };

        if (lookAndFeel.nudgeSettings.isEnabled) {
            return <Nudges />;
        }

        // Only show warning message if we have AI suggestions that aren’t
        // being shown because of our setting
        return (
            <>
                <Body size='small' color='dark'>
                    Smart nudges are disabled. Enable them in{' '}
                    <Link
                        // @ts-expect-error
                        as={RouterLink}
                        to='/inbox/settings/chat/engagement-bar'
                        variant='primary'
                        size='small'
                    >
                        engagement bar settings
                    </Link>
                    .
                </Body>
                <div style={{opacity: 0.4}}>
                    <Nudges />
                </div>
            </>
        );
    }

    return (
        <Body size='small' color='dark'>
            No smart nudges available
        </Body>
    );
}
